(() => {
  document.querySelectorAll('[data-pbh-reveal-partnership-form]').forEach((button) => {
    if (button.dataset.initialised === 'true') return;
    button.dataset.initialised = 'true';

    button.addEventListener('click', () => {
      const formSection = document.querySelector('[data-pbh-partnership-form]');
      if (!formSection) return;

      formSection.classList.add('partnership-form--revealed');
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const firstField = formSection.querySelector('input:not([type="hidden"]), textarea');
      if (firstField instanceof HTMLElement) {
        window.setTimeout(() => firstField.focus(), 400);
      }
    });
  });

  document.querySelectorAll('[data-pbh-partnership-cancel]').forEach((button) => {
    if (button.dataset.initialised === 'true') return;
    button.dataset.initialised = 'true';

    button.addEventListener('click', () => {
      const formSection = document.querySelector('[data-pbh-partnership-form]');
      formSection?.classList.remove('partnership-form--revealed');
    });
  });
})();
